var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.message)?_c('div',{staticClass:"notification-bar animated",class:_vm.animate},[_c('div',{staticClass:"box "},[_c('div',{staticClass:"box-inner"},[_c('i',{staticClass:"fa",class:_vm.icon}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.message))])])])]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-287047f4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Components/Elements/Notification.vue
// module id = DzHk
// module chunks = 0